module.exports = __webpack_public_path__ + "img/36ne.41a466ea.svg";